import {
  AnnualReportsDataTypes,
  AnnualReportsParamsTypes,
  CreateDownloadNowParamsTypes,
  CreateDownloadParamsTypes,
} from './type';

import axiosInstance from 'services/common/instance';

const getAnnualReportService = async (
  params: AnnualReportsParamsTypes,
): Promise<PaginationData<AnnualReportsDataTypes[]>> => {
  const response = await axiosInstance.get('annual-reports', { params });
  return response.data;
};

export const postCreteDownloadService = async (
  params: CreateDownloadParamsTypes,
): Promise<{link: string}> => {
  const formData = new FormData();
  formData.append('grecaptcha_token', params.grecaptcha_token);
  formData.append('annual_report_id', String(params.annual_report_id));
  const response = await axiosInstance.post(
    'annual-reports/create-download',
    formData,
  );
  return response.data.data;
};

export const postCreteDownloadNowService = async (
  params: CreateDownloadNowParamsTypes,
): Promise<{link : string}> => {
  const formData = new FormData();
  formData.append('grecaptcha_token', params.grecaptcha_token);
  formData.append('annual_report_id', String(params.annual_report_id));
  const response = await axiosInstance.post('annual-reports/create-download-now', formData);
  return response.data.data;
};

export default getAnnualReportService;
